import { DelegatingPasswordEncoder, NoopPasswordEncoder } from './password.ts';
import { Argon2PasswordEncoder } from './argon2.ts';

export const MAX_PASSWORD_LENGTH = 4096;

export interface PasswordEncoder {
    encode(rawPassword?: string): Promise<string | undefined>;

    matches(rawPassword?: string, encodedPassword?: string): Promise<boolean>;

    upgradeEncoding?(encodedPassword?: string): boolean;
}

export function createDelegatingPasswordEncoder(): PasswordEncoder {
    const idForEncode = 'argon2id';
    const encoders: Map<string, PasswordEncoder> = new Map<string, PasswordEncoder>([
        [idForEncode, new Argon2PasswordEncoder()], ['noop', NoopPasswordEncoder.instance]]);
    return new DelegatingPasswordEncoder(idForEncode, encoders, DelegatingPasswordEncoder.DEFAULT_ID_PREFIX, DelegatingPasswordEncoder.DEFAULT_ID_SUFFIX);
}
